import { Button, Checkbox, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useAuth } from "../../context/API_Client";
import "./login.css";
import ResetAndChangePassword from "./ResetAndChangePassword";
import CustomButton from "../../reusableComponents/CustomButton";
import { colorBrandObject } from "../../../constants/brandings";

function formatTime(seconds) {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  const formattedMinutes = String(minutes).padStart(2, "0");
  const formattedSeconds = String(remainingSeconds).padStart(2, "0");
  return `${formattedMinutes}:${formattedSeconds}`;
}

function ForgotPasswordOTP({
  title,
  subtitle,
  email,
  showReset,
  onOTPChange,
  editBackButton,
  mobileLayout,
  creating,
  twoFA,
  apiCallPostLogin,
}) {
  const { credentialsCheck, verifyOTP, twoFAAuth } = useAuth();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState([]);
  const [confirmButtonChange, setConfirmButtonChange] = useState(false);
  const [otpMessage, setOtpMessage] = useState([]);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [otpSentMessage, setOtpSentMessage] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [rememberTwoFactorAuth, setRememberTwoFactorAuth] = useState(true);
  const [loading, setLoading] = useState(false);
  let timer;

  const handleOTPChange = (newOTP) => {
    setError(null);
    setOtp(newOTP);
  };

  const handleKeyDown = (e) => {
    if (e?.key === "Enter" && otp?.length == 6)
      twoFA ? handleTwoFaLogin(e) : handleConfirmButton(e);
  };

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [otp]);

  useEffect(() => {
    let timer;

    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);
      }, 1000);
    }

    return () => {
      clearInterval(timer);
    };
  }, [countdown]);

  const handleResendOTP = () => {
    setOtpSentMessage(true);

    setTimeout(() => {
      setOtpSentMessage(false);
    }, 2000);

    setCountdown(30);

    credentialsCheck(
      { email },
      (data) => { },
      (errorMsg) => {
        setError(errorMsg);
      },
      twoFA
    );

    setTimeout(() => {
      clearInterval(timer);
    }, 60000);

    setOtp("");
    setError(null);
  };

  const handleTwoFaLogin = () => {
    setLoading(true);
    twoFAAuth(
      {
        email: email,
        token: otp,
        rememberTwoFactorAuth: rememberTwoFactorAuth,
      },
      (data) => {
        setLoading(false);
        // apiCallPostLogin();
      },
      (errorMsg) => {
        setLoading(false);
        setError(errorMsg);
      }
    );
  };

  const handleConfirmButton = () => {
    setLoading(true);
    verifyOTP(
      { email: email, otp: otp },
      (otpData) => {
        setOtpMessage(otpData.valid);
        if (otpData.valid) {
          setConfirmButtonChange(true);
          if (!creating) {
            showReset(true);
            onOTPChange(otp);
          }
          setShowResetPassword(true);
          setLoading(false);
        }
      },
      (errorMsg) => {
        setError(errorMsg);
        setLoading(false);
      }
    );
  };

  const handleEditClick = () => {
    editBackButton(false);
  };

  const inputStyle = {
    width: "100%",
    height: "50px",
    fontSize: "16px",
    textAlign: "center",
    border: "1px solid #ccc",
    borderRadius: "5px",
    margin: "5px",
  };

  return (
    <>
      {showResetPassword ? (
        <div>
          <ResetAndChangePassword
            id="reset_password"
            title={creating ? "Welcome!" : "Reset Password"}
            email={email}
            otp={otp}
            mobileLayout={mobileLayout}
            creating={creating}
          />
        </div>
      ) : (
        <div>
          <Typography
            style={{ marginTop: "23px" }}
            className="login-main-title1"
          >
            {title}
          </Typography>

          <p className="login-main-title2" sx={{ display: "flex" }}>
            {subtitle}
            <span
              style={{ color: "#403E9F", marginLeft: "4px", fontWeight: "600" }}
            >
              {email}{" "}
              <span>
                {" "}
                {!creating && (
                  <img
                    src="/assets/editIcon2.svg"
                    alt="Edit Icon"
                    style={{ cursor: "pointer" }}
                    onClick={handleEditClick}
                  />
                )}
              </span>
            </span>
          </p>
          <div
            style={{
              marginTop: mobileLayout ? "20px" : "48px",
              marginBottom: "5px",
            }}
          >
            <OTPInput
              inputType={"tel"}
              value={otp}
              onChange={(e) => {
                handleOTPChange(e);
              }}
              numInputs={6}
              renderSeparator={<span>&nbsp;&nbsp;</span>}
              renderInput={(props) => <input {...props} style={inputStyle} />}
            />
          </div>
          {error?.length > 0 && !otpSentMessage && (
            <div
              className="email-error"
              style={{
                alignItems: "flex-start",
                margin: "none",
                marginLeft: "3px",
                minHeight: "auto",
              }}
            >
              <img src="/assets/errorOutline.svg" style={{ marginTop: "-2px" }} />
              <Typography
                className="labelRegularRes"
                sx={{
                  color: "var(--Comms-Negative, #B9232F) !important",
                }}
              >
                {error}
              </Typography>
            </div>
          )}
          <div
            className="helper-text"
            style={{
              minHeight: "60px",
              marginLeft: "3px",
              marginTop: "4px",
            }}
          >
            <div>
              {twoFA && (
                <div
                  style={{ display: "flex", gap: "4px", alignItems: "center" }}
                >
                  <Checkbox
                    checked={rememberTwoFactorAuth}
                    sx={{
                      '& .MuiSvgIcon-root': {
                        color: colorBrandObject?.secondaryButtonColor,
                        fontSize: "16px"
                      },
                      '&.Mui-checked': {
                        color: colorBrandObject?.secondaryButtonColor,
                        '& .MuiSvgIcon-root': {
                          fill: colorBrandObject?.secondaryButtonColor,
                        },
                      },
                    }}
                    onChange={() => {
                      setRememberTwoFactorAuth((prev) => !prev);
                    }}
                  />
                  <Typography className="resend-text">
                    Do not ask for 24 hours
                  </Typography>
                </div>
              )}
            </div>
            <div>
              {countdown > 0 && !otpSentMessage && !creating ? (
                <div
                  style={{
                    display: "flex",

                    marginRight: "5px",
                  }}
                >
                  <Typography className="resend-text">
                    Resend code in
                  </Typography>
                  <Typography>&nbsp;</Typography>
                  <Typography className="resend-text-time">
                    {formatTime(countdown)}
                  </Typography>
                </div>
              ) : (
                !otpSentMessage &&
                !creating && (
                  <Typography
                    className="resend-otp"
                    sx={{}}
                    onClick={handleResendOTP}
                  >
                    Resend code
                  </Typography>
                )
              )}
            </div>
          </div>

          <CustomButton
            variant={"contained"}
            width={"100%"}
            color="primary"
            size={mobileLayout ? "xxl" : "xxxl"}
            text={twoFA ? "Verify and Login" : "Confirm"}
            onClick={twoFA ? handleTwoFaLogin : handleConfirmButton}
            disabled={otp?.length < 6}
            loading={loading}
          />
        </div>
      )}
    </>
  );
}

export default ForgotPasswordOTP;
